import { parseSearchQuery } from 'shared/utils/RoutingHelpers';

export const CARRIER_FIRST_TOUCH_STORAGE_KEY = 'carrier_signup_first_touch_v1';

function getQueryParam(
  query: ReturnType<typeof parseSearchQuery>,
  paramName: string,
): string | undefined {
  const raw = query[paramName];
  if (raw == null) {
    return undefined;
  }

  const trimmed = String(raw).trim();
  if (trimmed === '') {
    return undefined;
  }

  return trimmed;
}

export function captureFirstTouchValues() {
  if (localStorage.getItem(CARRIER_FIRST_TOUCH_STORAGE_KEY)) {
    return;
  }

  const searchParams = parseSearchQuery(window.location.search);
  const firstTouchValues: Record<string, string> = {};
  const utmPairs: [string, string][] = [
    ['utm_source', 'signup_utm_source'],
    ['utm_medium', 'signup_utm_medium'],
    ['utm_campaign', 'signup_utm_campaign'],
    ['utm_term', 'signup_utm_term'],
    ['utm_content', 'signup_utm_content'],
  ];

  for (const [queryName, outName] of utmPairs) {
    const paramValue = getQueryParam(searchParams, queryName);
    if (paramValue) {
      firstTouchValues[outName] = paramValue;
    }
  }

  firstTouchValues['signup_landing_page_url'] = window.location.href;
  if (document.referrer) {
    firstTouchValues['signup_referrer_url'] = document.referrer;
  }

  localStorage.setItem(
    CARRIER_FIRST_TOUCH_STORAGE_KEY,
    JSON.stringify(firstTouchValues),
  );
}

export function getFirstTouchFields(): Record<string, string> {
  const raw = localStorage.getItem(CARRIER_FIRST_TOUCH_STORAGE_KEY) || '';

  try {
    return JSON.parse(raw) as Record<string, string>;
  } catch {
    return {};
  }
}
